<template>
  <div>
    <div v-if="passwordSet">
      <div class="border-green-light border-t-4 font-light rounded-t bg-green-lightest px-4 py-1 text-green-darker" role="alert" v-show="success" v-text="success"></div>
    </div>
    <div v-else>
      <update-password @success="populateFields" @errors="showErrors">
        <div slot-scope="{ pwProps, pwEvents, pwcProps, pwcEvents, errors }">
          <div class="md:flex mt-4">
            <div class="md:flex-1 md:pr-3">
              <label class="block uppercase tracking-wide text-charcoal-darker text-xs font-bold">Password</label>
              <input
                class="w-full shadow-inner p-4 border-0 bg-grey-lighter"
                type="password"
                name="password"
                placeholder="*******"
                v-bind="pwProps"
                v-on="pwEvents">
            </div>
            <div class="md:flex-1 md:pl-3">
              <label class="block uppercase tracking-wide text-charcoal-darker text-xs font-bold">Verify Password</label>
              <input
                class="w-full shadow-inner p-4 border-0 bg-grey-lighter"
                type="password"
                name="verify_password"
                placeholder="*******"
                autocomplete="off"
                v-bind="pwcProps"
                v-on="pwcEvents">
            </div>
          </div>
        </div>
      </update-password>
      <div class="md:flex md:items-center md:justify-between mt-6">
        <div class="md:flex-1 pr-4">
          <div class="border-red-light border-t-4 font-light rounded-t bg-red-lightest px-4 py-1 text-red-darker" role="alert" v-show="errors" v-text="errors"></div>
          <div class="border-green-light border-t-4 font-light rounded-t bg-green-lightest px-4 py-1 text-green-darker" role="alert" v-show="success" v-text="success"></div>
        </div>
        <div class="text-center md:text-right">
          <button class="button text-cream-lighter bg-brick hover:bg-brick-dark" type="submit" @click.prevent="sendForm">Update Profile</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpdatePassword from './UpdatePassword'

export default {
  props: ['user'],
  components: {
    UpdatePassword
  },
  data() {
    return {
      password: '',
      confirm: '',
      errors: '',
      success: '',
      passwordSet: false
    }
  },
  methods: {
    sendForm() {
      this.success = ''
      if (this.password && this.confirm) {
        axios.patch('/api/v1/settings/password', {
          user: this.user,
          password: this.password,
          verify_password: this.confirm
        }).then(({data}) => {
          if (data.error) {
             this.success = ''
            this.errors = data.error
            return
          }
          this.success = data.success
          this.passwordSet = true
          this.$emit('passwordSet')
        }).catch((response) => {
          console.log(response)
        })
      } else {
         this.success = ''
        this.errors = this.errors ? this.errors : "Please enter a password."
      }
    },
    populateFields(data) {
      this.errors = ''
      this.success = ''
      this.password = data.password
      this.confirm = data.confirm
    },
    showErrors(error) {
      this.success = ''
      this.errors = error.message
    }
  }
}
</script>
